// extracted by mini-css-extract-plugin
export default {"AgentTill":"AgentTill_AgentTill__VD0Og","list":"AgentTill_list__Py49i"};